import { render, staticRenderFns } from "./PopupAsForm.vue?vue&type=template&id=0567351c&"
import script from "./PopupAsForm.vue?vue&type=script&lang=js&"
export * from "./PopupAsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports